import { translateKey } from '../../../translate';
import { Container } from '../../elements/molecules/container/Container';
import { Main } from '../../elements/molecules/main/Main';
import { Header } from '../../elements/organisms/header/Header';
import { PageWrapper } from '../../elements/organisms/pageWrapper/PageWrapper';

export function GeneralError({ rumSessionId }: { rumSessionId?: string }) {
    return (
        <PageWrapper>
            <Header hasLogoutButton />
            <Main>
                <Container isFluidOnMobile>
                    <h1>{translateKey('errorPages.generalTitle')}</h1>
                    <p>{translateKey('errorPages.generalBody')}</p>
                    {rumSessionId && <p>{`${translateKey('errorPages.rumSessionId')}: ${rumSessionId}`}</p>}

                    <small>
                        {translateKey('errorPages.generalNeedHelp')}{' '}
                        <a
                            className="link tertiary"
                            href="tel:+31206000060"
                        >
                            020 600 00 60
                        </a>
                        <br />
                        {translateKey('errorPages.generalOpeningHours')}
                    </small>
                    <a
                        className="link"
                        href="mailto:info@ksyos.nl"
                        rel="noopener noreferrer"
                    >
                        {translateKey('errorPages.generalSendEmail')}
                    </a>
                </Container>
            </Main>
        </PageWrapper>
    );
}
